/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Date_EndInputs */



/**
* | output |
* | --- |
* | "Custom Date End" |
*
* @param {Custom_Date_EndInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom_date_end = /** @type {((inputs?: Custom_Date_EndInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Date_EndInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fin de période personnalisée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerdefiniertes Enddatum")
	if (locale === "it") return /** @type {LocalizedString} */ ("Data di fine personalizzata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пользовательская дата окончания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fecha de finalización personalizada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自定义日期结束")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カスタム日付終了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कस्टम दिनांक समाप्ति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Data de término personalizada")
	return /** @type {LocalizedString} */ ("Custom Date End")
});